/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseChatHistoryData } from './genericApiResponseChatHistoryData';
import type { GenericApiResponseChatHistoryMessage } from './genericApiResponseChatHistoryMessage';
import type { GenericApiResponseChatHistoryPagination } from './genericApiResponseChatHistoryPagination';
import type { GenericApiResponseChatHistoryError } from './genericApiResponseChatHistoryError';

export interface GenericApiResponseChatHistory {
  data?: GenericApiResponseChatHistoryData;
  message?: GenericApiResponseChatHistoryMessage;
  pagination?: GenericApiResponseChatHistoryPagination;
  error?: GenericApiResponseChatHistoryError;
  statusCode?: number;
}
